import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected, PayloadAction } from "@reduxjs/toolkit";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";
import { MyPlanDetail } from "../MyPlanDetails/MyPlanDetail";

const SLICE = "CopyToPlan";

const isCopyToPlanThunk = (action: any) => action.type.startsWith(`${SLICE}/`); // This is to check fullfilled and rejected cases only for CopyToPlan Slice.

const initialState: any = {
  loadingCount: 0,
  plansList: [],
  myPlanDetails: []
};

export const copySectionAsync = createAsyncThunk(`${SLICE}/copySection`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.postPlans, data, thunkApi, [data.planId, "sections"])
);

export const copyActionAsync = createAsyncThunk(`${SLICE}/copyAction`, (data: any, thunkApi) => {
  const { planId, sectionId } = data.url;
  return apiRequest(USER_PLAN_SERVICE_METHOD.postPlans, data.payload, thunkApi, [
    planId,
    "sections",
    sectionId,
    "cards"
  ]);
});

export const fetchMyPlansWithInncodesAsync = createAsyncThunk(
  `${SLICE}/fetchMyPlansWithInncodesAsync`,
  async (data: any, thunkApi) =>
    apiRequest(USER_PLAN_SERVICE_METHOD.postAbovePropertyPlans, data, thunkApi, [], { size: data.size })
);

export const fetchMyPlanDetailAsync = createAsyncThunk(`${SLICE}/fetchMyPlanDetailAsync`, (data: any, thunkApi) => {
  return apiRequest(USER_PLAN_SERVICE_METHOD.getPlans, {}, thunkApi, [data.id]);
});

export const CopyToPlan = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPlansWithInncodesAsync.fulfilled, (state, action) => {
        state.plansList = action.payload.userplans;
      })
      .addCase(fetchMyPlanDetailAsync.fulfilled, (state, action: PayloadAction<MyPlanDetail>) => {
        state.myPlanDetails = action.payload;
      })
      .addMatcher(
        (action) => isPending(action) && isCopyToPlanThunk(action),
        (state) => {
          state.loadingCount += 1;
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isCopyToPlanThunk(action),
        (state) => {
          state.loadingCount -= 1;
        }
      );
  }
});

export const { reset } = CopyToPlan.actions;

export default CopyToPlan.reducer;
